// src/components/Layout.js
import React from "react";
import { Box } from "@mui/material";
import NavBar from "./NavBar";
import TopNavLinks from './TopNavLinks';
import OnboardingBanner from './OnboardingBanner';
import AnimatedGradientBackground from './onboarding/AnimatedGradientBackground';
import { useLocation } from 'react-router-dom';

export default function Layout({ children, mode = "light", onToggleTheme }) {
  const isDarkMode = mode === "dark";
  const location = useLocation();
  const hideTopNav = location && location.pathname && location.pathname.startsWith('/time-clock');
  const isOnboardingRoute = location && location.pathname && location.pathname.startsWith('/onboarding');

  // main top offset: when on onboarding we want a full-bleed experience (no top spacing)
  const mainSx = isOnboardingRoute ? { mt: 0, p: 0 } : { mt: `calc(var(--appbar-height, var(--app-top, 64px)) + var(--nav-height, 36px))`, p: 1 };

  return (
    <>
      {/* Navigation Bar */}
      {!isOnboardingRoute && <NavBar darkMode={isDarkMode} onToggleDarkMode={onToggleTheme} />}

  {/* Onboarding full-bleed animated gradient background */}
  {isOnboardingRoute && <AnimatedGradientBackground />}

      {/* Top navigation links (fixed under the AppBar). Hidden on time-clock pages */}
      {!hideTopNav && !isOnboardingRoute && (
        <Box sx={{ position: 'fixed', left: 0, right: 0, top: 'var(--appbar-height, var(--app-top, 64px))', zIndex: (theme) => theme.zIndex.appBar + 10, bgcolor: 'background.paper', borderBottom: 1, borderColor: 'divider', '--nav-height': '36px' }}>
          <TopNavLinks darkMode={isDarkMode} onToggleDarkMode={onToggleTheme} />
        </Box>
      )}

      {/* Main Content: when onboarding route, render full-bleed children so OnboardingLayout can control the background */}
      <Box component="main" sx={mainSx}>
        {!isOnboardingRoute && (() => {
          const adminUser = typeof window !== 'undefined' ? localStorage.getItem('adminUser') : null;
          if (!adminUser) {
            return <OnboardingBanner />;
          }
          return null;
        })()}

        {(() => {
          if (isOnboardingRoute) {
            // render children directly so onboarding layout is full-bleed
            return children;
          }

          const isFullWidthRoute = location && location.pathname && (
            location.pathname.startsWith('/schedule-creation') ||
            location.pathname.startsWith('/time-entries') ||
            location.pathname.startsWith('/settings')
          );
          return (
            <Box sx={{ width: '100%', maxWidth: isFullWidthRoute ? 'none' : 1200, mx: isFullWidthRoute ? 0 : 'auto', px: isFullWidthRoute ? 0 : 2 }}>
              {children}
            </Box>
          );
        })()}
      </Box>
    </>
  );
}
